import React, { useEffect, useState } from 'react'; 
import { Button } from '@progress/kendo-react-buttons';
import { FormSubTitleDespHybrid, FormTitleHybrid } from '../validation/Form-Components';
import MYCAIcon from '../hybridImages/MYCurrentAcctIcon.png';
import { Checkbox } from '@progress/kendo-react-inputs';
import learnMoreIcon from '../hybridImages/LearnMoreIcon.png'
import FXIcon from '../hybridImages/FXIcon.png';
import BizInsuranceIcon from '../hybridImages/BizInsuranceIcon.png';
import SMEIcon from '../hybridImages/SMESDIcon.png';
import HalalIcon from '../hybridImages/HalalIcon.png';
import nldata from '../hybriddata/nonlendingdata.json';
import service from '../services/ApiService.js';
import storage from '../factory/StorageFactory.js';
import Loading from '../components/Loading.jsx';
import CusToast from '../components/CusToast.jsx';
import config from '../appconfig/config.json';
import pService from '../services/PreviewApiService.js';
import { useHistory } from "react-router-dom";

const NonLendingSolutions = (props) => {

    let timer; 
    const preKOSubmitted = 'Submitted';
    const nlSubmitted = 'Y';
    const history = useHistory();

    const [checkedMYCA,setCheckedMYCA] = useState(false);
    const [checkedFXDeskServices,setCheckedFXDeskServices] = useState(false);
    const [checkedBizInsurance,setCheckedBizInsurance] = useState(false);
    const [checkedSMEDigital,setCheckedSMEDigital] = useState(false);
    const [checkedHalalNCA,setcheckedHalalNCA] = useState(false);
    const [isLoading,setIsLoading] = useState(false);
    const [isError,setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');
    const [response,setResponse] = useState(props.response);

    useEffect(() => {
        console.log('@NonLendingSolutions useEffect');
        // console.log('trigger',props.trigger)
        getData();

        return () => {
            clearTimeout(timer);
        }
    }, []);


    const getData = () => {
        setIsLoading(true);
        const rno = storage.getRefNo();
        service.getNonLending(rno).then( res =>{
            setIsLoading(false);
            if(res.data.isSucess) {
                const resData = res.data.model;
                bindData(resData);
            }
            else {
                showErrMsg(config.error.GetApiFailed);
            }
        })
        .catch(err=>{
            console.log('err=>',err);
            setIsLoading(false);
            showErrMsg(config.error.GetApiFailed);
        })
    }

    const bindData = (resData) => {
        setCheckedMYCA(resData.myCurrentAccount === 'Y'?true:false);
        setCheckedFXDeskServices(resData.fxDeskServices === 'Y'?true:false);
        setCheckedBizInsurance(resData.businessInsurance === 'Y'?true:false);
        setCheckedSMEDigital(resData.smeStartDigital === 'Y'?true:false);
        setcheckedHalalNCA(resData.halalNetworkAndCertifiedAdvisory === 'Y'? true:false);
    }
    
    const saveNonLending = (params) => {

        setIsLoading(true);

        service.postNonLending(params).then( res => {
            // setIsLoading(false);
            if(res.data.isSucess) { 
                setTimeout(() => {
                    submitWithFields()
                }, config.DelayTimeout);
            }
            else {
                showErrMsg(config.error.SaveApiFailed);
            }
        })
        .catch(err=>{
            console.log('err=>',err);
            setIsLoading(false);
            showErrMsg(config.error.SaveApiFailed);
        })
    }

    const handleNotNow = (e)=> {
        const rno = storage.getRefNo();
        const params = {
            referenceno:rno,
            BusinessInsurance: 'N',
            FXDeskServices : 'N',
            HalalNetworkAndCertifiedAdvisory : 'N',
            MYCurrentAccount : 'N',
            SMEStartDigital : 'N'
        }

        saveNonLending(params);
    }

    const handleDone = (e)=> {
        const rno = storage.getRefNo();
        const params = {
            referenceno:rno,
            BusinessInsurance: checkedBizInsurance?'Y':'N',
            FXDeskServices : checkedFXDeskServices?'Y':'N',
            HalalNetworkAndCertifiedAdvisory : checkedHalalNCA?'Y':'N',
            MYCurrentAccount : checkedMYCA?'Y':'N',
            SMEStartDigital : checkedSMEDigital?'Y':'N'
        }
        saveNonLending(params);
    }

    const openLink = (url) => {
        window.open(url,'_blank')
    }

    const disabledDoneBtn = () => {
        if(checkedMYCA || checkedFXDeskServices || checkedBizInsurance ||
            checkedSMEDigital || checkedHalalNCA) {
                return false;
        }
        else {
            return true;
        }
    }

    const getIsPureAIPSubmission = () => {
        if(storage.getIsAIPSubmission() === 'Y') {
          return 'Y';
        }
        else {
          return 'N';
        }
      }

    const submitWithFields = () => {

        let params = {
            RefNo:storage.getRefNo(),
            OrderNumber:response.ApplicantOrderNum,
            IDNumber:response.ApplicantIDNum,
            Status: preKOSubmitted,  // addtional for PreKnockout Status
            isAuthorisedPerson: storage.getIsGreenAP(),
            IsNonLendingCompleted:nlSubmitted
        }
        
        pService.submit(params).then(res => {   
            setIsLoading(false);
            if(res.data.isSucess) {
              if(res.data.model.refNo === null || res.data.model.refNo === '') {
                goPreKnockoutFailed('M21'); //submit to waa failed
                return;
              }
              //success
              props.setTrigger(false);
              props.onActionDone();
            }  
            else {
                if(res.data.model.refNo === null || res.data.model.refNo === '') {
                    goPreKnockoutFailed('M21'); //submit to waa failed
                    return;
                }
                showErrMsg(config.error.SaveApiFailed);
            } 
        }).catch(err => {
            setIsLoading(false);
            console.log('err: ',err);
            showErrMsg(config.error.SaveApiFailed);
        })
    }

    const goPreKnockoutFailed = (errorType) => {
        let errCode;
        if(errorType === null) {
          errCode= 'M12';
        }
        else {
          errCode = errorType;
        }
       
        history.push(config.route.PreKnockoutFailed,{errType:errCode});
    }


    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout();
    }

    const setErrMsgTimeout= () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }

    return props.trigger &&(
        <div className="popup">
            <div className="nl-popup-inner popup-inner-full-width" >
                <div className='container-fluid'>
                    <FormTitleHybrid id={'ft1'} 
                        name={nldata.formTitle} />
                    <FormSubTitleDespHybrid id={'ftdesp1'} 
                         name={nldata.formSubTitle} />
                    <div className="scroll-row inputPair">
                        <div className="nl-col">
                            <div className={checkedMYCA?'nl-yellowbox':'nl-greybox'}>
                                <div className='chk-align-rgt'>
                                    <Checkbox 
                                        style={{borderRadius:'3px',borderColor:'#D7D7D7'}}
                                        id={'chkMYCurrentAcct'}
                                        name={'chkMYCurrentAcct'}
                                        checked={checkedMYCA} 
                                        onChange={(e) => {
                                            setCheckedMYCA(e.value);
                                        }}
                                    />
                                </div>
                                <div className='nl-imgbox'>
                                    <img className='greyboxImg' src={MYCAIcon} alt='MYCAIcon' />
                                </div>
                                <div className='title-div-hgt nl-txt-title'>
                                    {nldata.product1.title}
                                </div>
                                <div className='greySboxBoldDiv nl-txt-desc'>
                                    {nldata.product1.desc}
                                </div>
                                <div className="nl-divgreyline" />
                                <div className='nl-div-learn-more'>
                                    <span className="nl-learn-more-txt" 
                                        onClick={()=> {
                                            openLink(nldata.product1.link)
                                        }}>
                                        <span>Learn more</span>
                                        <img className='learnMoreImgSize' src={learnMoreIcon} alt='MYCAIcon' />
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="nl-col">
                            <div className={checkedFXDeskServices?'nl-yellowbox':'nl-greybox'}>
                                <div className='chk-align-rgt'>
                                    <Checkbox 
                                        style={{borderRadius:'3px',borderColor:'#D7D7D7'}}
                                        id={'chkFXDeskServices'}
                                        name={'chkFXDeskServices'}
                                        checked={checkedFXDeskServices} 
                                        onChange={(e) => {
                                            setCheckedFXDeskServices(e.value);
                                        }}
                                    />
                                </div>
                                <div className='nl-imgbox'>
                                    <img className='greyboxImg' src={FXIcon} alt='FXDeskServicesIcon' />
                                </div>
                                <div className='title-div-hgt nl-txt-title'>
                                    {nldata.product2.title}
                                </div>
                                <div className='greySboxBoldDiv nl-txt-desc'>
                                    {nldata.product2.desc}
                                </div>
                                <div className="nl-divgreyline" />
                                <div className='nl-div-learn-more'>
                                    <span className="nl-learn-more-txt" 
                                        onClick={()=> {
                                            openLink(nldata.product2.link)
                                        }}>
                                        <span>Learn more</span>
                                        <img className='learnMoreImgSize' src={learnMoreIcon} alt='MYCAIcon' />
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="nl-col">
                            <div className={checkedBizInsurance?'nl-yellowbox':'nl-greybox'}>
                                <div className='chk-align-rgt'>
                                    <Checkbox 
                                        style={{borderRadius:'3px',borderColor:'#D7D7D7'}}
                                        id={'chkBizInsurance'}
                                        name={'chkBizInsurance'}
                                        checked={checkedBizInsurance} 
                                        onChange={(e) => {
                                            setCheckedBizInsurance(e.value);
                                        }}
                                    />
                                </div>
                                <div className='nl-imgbox'>
                                    <img className='greyboxImg' src={BizInsuranceIcon} alt='BizInsuranceIcon' />
                                </div>
                                <div className='title-div-hgt nl-txt-title'>
                                    {nldata.product3.title}
                                </div>
                                <div className='greySboxBoldDiv nl-txt-desc'>
                                    {nldata.product3.desc}
                                </div>
                                <div className="nl-divgreyline" />
                                <div className='nl-div-learn-more'>
                                    <span className="nl-learn-more-txt" 
                                        onClick={()=> {
                                            openLink(nldata.product3.link)
                                        }}>
                                        <span>Learn more</span>
                                        <img className='learnMoreImgSize' src={learnMoreIcon} alt='MYCAIcon' />
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="nl-col">
                            <div className={checkedSMEDigital?'nl-yellowbox':'nl-greybox'}>
                                <div className='chk-align-rgt'>
                                    <Checkbox 
                                        style={{borderRadius:'3px',borderColor:'#D7D7D7'}}
                                        id={'chkSMEDigital'}
                                        name={'chkSMEDigital'}
                                        checked={checkedSMEDigital} 
                                        onChange={(e) => {
                                            setCheckedSMEDigital(e.value);
                                        }}
                                    />
                                </div>
                                <div className='nl-imgbox'>
                                    <img className='greyboxImg' src={SMEIcon} alt='SMEIcon' />
                                </div>
                                <div className='title-div-hgt nl-txt-title'>
                                    {nldata.product4.title}
                                </div>
                                <div className='greySboxBoldDiv nl-txt-desc'>
                                    {nldata.product4.desc}
                                </div>
                                <div className="nl-divgreyline" />
                                <div className='nl-div-learn-more'>
                                    <span className="nl-learn-more-txt" 
                                        onClick={()=> {
                                            openLink(nldata.product4.link)
                                        }}>
                                        <span>Learn more</span>
                                        <img className='learnMoreImgSize' src={learnMoreIcon} alt='MYCAIcon' />
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="nl-col">
                            <div className={checkedHalalNCA?'nl-yellowbox':'nl-greybox'}>
                                <div className='chk-align-rgt'>
                                    <Checkbox 
                                        style={{borderRadius:'3px',borderColor:'#D7D7D7'}}
                                        id={'chkHalalNCA'}
                                        name={'chkHalalNCA'}
                                        checked={checkedHalalNCA} 
                                        onChange={(e) => {
                                            setcheckedHalalNCA(e.value);
                                        }}
                                    />
                                </div>
                                <div className='nl-imgbox'>
                                    <img className='greyboxImg' src={HalalIcon} alt='HalalIcon' />
                                </div>
                                <div className='title-div-hgt nl-txt-title'>
                                    {nldata.product5.title}
                                </div>
                                <div className='greySboxBoldDiv nl-txt-desc'>
                                    {nldata.product5.desc}
                                </div>
                                <div className="nl-divgreyline" />
                                <div className='nl-div-learn-more'>
                                    <span className="nl-learn-more-txt" 
                                        onClick={()=> {
                                            openLink(nldata.product5.link)
                                        }}>
                                        <span>Learn more</span>
                                        <img className='learnMoreImgSize' src={learnMoreIcon} alt='MYCAIcon' />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='nl-div-pd'>
                        <div className="row around-xs inputPair elementVisible">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <div className='lbl-note-grey smallFontSize'>   
                                    {nldata.formNote}   
                                </div>
                            </div>             
                        </div>
                        
                    </div>
                    <div>
                        <div style={{ textAlign: "center", justifyContent: 'space-evenly', flexWrap: 'wrap',paddingBottom:'30px'}}>
                            <div className="sccbtMid">
                                <Button
                                    type={'button'}
                                    look="outline"
                                    className="btSize3 btLft3 nl-btn-w"
                                    disabled={!disabledDoneBtn()}
                                    onClick={handleNotNow} >
                                    {'NOT NOW'}
                                </Button>
                                <Button
                                    type={'submit'} 
                                    className="btSize3G btRht3 btn-success nl-btn-w"
                                    disabled={disabledDoneBtn()}
                                    onClick={handleDone}>
                                    {'DONE'}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isLoading&& <Loading />}
            <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer} /> 
        </div>
    )
}

export default NonLendingSolutions;